export default "__VITE_ASSET__CCcWSvZm__"